import {
  Blocks,
  Bot,
  BotMessageSquare,
  FileText,
  Search,
  Tags,
  Workflow,
} from "lucide-react";
import React from "react";

import { List } from "@mui/material";
import { IgListItemLink } from "@src/components/Navigation/BaseSideNav/IgListItemLink";
import { ADMIN_ROUTES, AI_ROUTES } from "@src/routes/routes";
import type { MainRoute } from "@src/types/navigation";

interface AiSideNavBarBodyProps {
  drawerOpen: boolean;
}

const aiSideNavRoutes: MainRoute[] = [
  {
    path: AI_ROUTES.AiWorkflowBuilder,
    sidebarName: "Workflow Builder",
    icon: <Workflow size={16} />,
  },
  {
    path: AI_ROUTES.AiAgents,
    sidebarName: "Agents",
    icon: <BotMessageSquare size={16} />,
  },
  {
    path: AI_ROUTES.AiAgenticLogic,
    sidebarName: "Agentic Logic",
    icon: <Blocks size={16} />,
  },
  {
    path: AI_ROUTES.AiExperimentClassifications,
    sidebarName: "Experiment Classifications",
    icon: <Tags size={16} />,
  },
  {
    path: ADMIN_ROUTES.KnowledgeManagement,
    sidebarName: "Knowledge Base",
    icon: <FileText size={16} />,
  },
  {
    path: AI_ROUTES.AiBotReview,
    sidebarName: "Chats with Charlie",
    icon: <Bot size={16} />,
  },
  {
    path: ADMIN_ROUTES.QaBotReview,
    sidebarName: "Franks Findings",
    icon: <Search size={16} />,
  },
];

export const AiSideNavBarBody = ({ drawerOpen }: AiSideNavBarBodyProps) => {
  return (
    <List sx={{ px: drawerOpen ? 2 : 4 }}>
      {aiSideNavRoutes.map((route) => (
        <IgListItemLink
          key={route.path}
          Route={route}
          drawerOpen={drawerOpen}
          hasAccess={true}
        />
      ))}
    </List>
  );
};
